export default function Utils ()
{
  const zGif = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
  const name2HexColorsList = { aliceblue: 'F0F8FF', antiquewhite: 'FAEBD7', aqua: '00FFFF', aquamarine: '7FFFD4', azure: 'F0FFFF', beige: 'F5F5DC', bisque: 'FFE4C4', black: '000000', blanchedalmond: 'FFEBCD', blue: '0000FF', blueviolet: '8A2BE2', brown: 'A52A2A', burlywood: 'DEB887', cadetblue: '5F9EA0', chartreuse: '7FFF00', chocolate: 'D2691E', coral: 'FF7F50', cornflowerblue: '6495ED', cornsilk: 'FFF8DC', crimson: 'DC143C', cyan: '00FFFF', darkblue: '00008B', darkcyan: '008B8B', darkgoldenrod: 'B8860B', darkgray: 'A9A9A9', darkgreen: '006400', darkkhaki: 'BDB76B', darkmagenta: '8B008B', darkolivegreen: '556B2F', darkorange: 'FF8C00', darkorchid: '9932CC', darkred: '8B0000', darksalmon: 'E9967A', darkseagreen: '8FBC8B', darkslateblue: '483D8B', darkslategray: '2F4F4F', darkturquoise: '00CED1', darkviolet: '9400D3', deeppink: 'FF1493', deepskyblue: '00BFFF', dimgray: '696969', dodgerblue: '1E90FF', firebrick: 'B22222', floralwhite: 'FFFAF0', forestgreen: '228B22', fuchsia: 'FF00FF', gainsboro: 'DCDCDC', ghostwhite: 'F8F8FF', gold: 'FFD700', goldenrod: 'DAA520', gray: '808080', green: '008000', greenyellow: 'ADFF2F', honeydew: 'F0FFF0', hotpink: 'FF69B4', indianred: 'CD5C5C', indigo: '4B0082', ivory: 'FFFFF0', khaki: 'F0E68C', lavender: 'E6E6FA', lavenderblush: 'FFF0F5', lawngreen: '7CFC00', lemonchiffon: 'FFFACD', lightblue: 'ADD8E6', lightcoral: 'F08080', lightcyan: 'E0FFFF', lightgoldenrodyellow: 'FAFAD2', lightgreen: '90EE90', lightgrey: 'D3D3D3', lightpink: 'FFB6C1', lightsalmon: 'FFA07A', lightseagreen: '20B2AA', lightskyblue: '87CEFA', lightslategray: '778899', lightsteelblue: 'B0C4DE', lightyellow: 'FFFFE0', lime: '00FF00', limegreen: '32CD32', linen: 'FAF0E6', magenta: 'FF00FF', maroon: '800000', mediumaquamarine: '66CDAA', mediumblue: '0000CD', mediumorchid: 'BA55D3', mediumpurple: '9370DB', mediumseagreen: '3CB371', mediumslateblue: '7B68EE', mediumspringgreen: '00FA9A', mediumturquoise: '48D1CC', mediumvioletred: 'C71585', midnightblue: '191970', mintcream: 'F5FFFA', mistyrose: 'FFE4E1', moccasin: 'FFE4B5', navajowhite: 'FFDEAD', navy: '000080', oldlace: 'FDF5E6', olive: '808000', olivedrab: '6B8E23', orange: 'FFA500', orangered: 'FF4500', orchid: 'DA70D6', palegoldenrod: 'EEE8AA', palegreen: '98FB98', paleturquoise: 'AFEEEE', palevioletred: 'DB7093', papayawhip: 'FFEFD5', peachpuff: 'FFDAB9', peru: 'CD853F', pink: 'FFC0CB', plum: 'DDA0DD', powderblue: 'B0E0E6', purple: '800080', red: 'FF0000', rosybrown: 'BC8F8F', royalblue: '4169E1', saddlebrown: '8B4513', salmon: 'FA8072', sandybrown: 'F4A460', seagreen: '2E8B57', seashell: 'FFF5EE', sienna: 'A0522D', silver: 'C0C0C0', skyblue: '87CEEB', slateblue: '6A5ACD', slategray: '708090', snow: 'FFFAFA', springgreen: '00FF7F', steelblue: '4682B4', tan: 'D2B48C', teal: '008080', thistle: 'D8BFD8', tomato: 'FF6347', turquoise: '40E0D0', violet: 'EE82EE', wheat: 'F5DEB3', white: 'FFFFFF', whitesmoke: 'F5F5F5', yellow: 'FFFF00', yellowgreen: '9ACD32' };

  const generateRandomId = (args) =>
  {
    Math.random().toString(args.radix).slice(2);
  };


  this.getRandomId = (args = {}) =>
  {
    args.radix = args.radix || 36;
    args.prefix = args.hasOwnProperty('prefix') ? args.prefix : 'id';
    args.length = args.length || 0;

    let id = generateRandomId(args);

    if (args.length > 0)
    {
      if (id.length < args.length)
      {
        while (id.length < args.length)
        {
          id += generateRandomId(args);
        }
      }

      id = id.substring(0, args.length);
    }

    return args.prefix + id;
  };


  this.getUniqueIdentifier = () => Math.floor(Math.random() * (new Date()).getTime() * 10000);
  this.getKeyCode = (e) => (e.keyCode ? e.keyCode : (e.charCode ? e.charCode : 0));
  this.getZGif = () => zGif;


  this.getFrameByWindow = (w) =>
  {
    let frames, len, fc, fw, i, locationDomain;

    try
    {
      frames = w.parent.document.getElementsByTagName('IFRAME');
    }
    catch (e)
    {
      return null;
    }

    len = frames.length;
    fc = null;
    locationDomain = BEditor.environment.getLocationDomain();

    for (i = 0; i < len; i++)
    {
      try
      {
        if (!frames[i].src || frames[i].src.toLowerCase().indexOf(locationDomain) === 0)
        {
          fw = (BEditor.browser.isIE) ? frames[i].contentWindow : frames[i].contentDocument.defaultView;

          if (fw === w)
          {
            return frames[i];
          }
        }
      }
      catch (err) {}
    }

    return null;
  };


  this.convertColorToHex = (c) =>
  {
    c = c.replace(/.*?(#(?:[ABCDEF0-9]{6}|[ABCDEF0-9]{3})|rgb\s*\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\))/i, "$1");

    let m = c.match(/^\s*#?([ABCDEF0-9]{6}|[ABCDEF0-9]{3})\s*$/i);

    if (m && m.length === 2)
    {
      return m[1].toUpperCase();
    }
    else if (name2HexColorsList[c])
    {
      return name2HexColorsList[c];
    }
    else if (c.toString().toLowerCase().indexOf('rgb') !== -1)
    {
      m = c.match(/(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/);

      if (m && m.length === 4)
      {
        return ((((parseInt(m[1]).toString(16).length === 1) ? '0' : '') + parseInt(m[1]).toString(16).toUpperCase()) + (((parseInt(m[2]).toString(16).length === 1) ? '0' : '') + parseInt(m[2]).toString(16).toUpperCase()) + (((parseInt(m[3]).toString(16).length === 1) ? '0' : '') + parseInt(m[3]).toString(16).toUpperCase()));
      }
    }
    else
    {
      return null;
    }
  };


  this.encodeHtml = (html) =>
  {
    html = ((html != null) ? html.toString() : '');

    let result = '';

    for (let i = 0; i < html.length; i++)
    {
      let charCode = html.charCodeAt(i),
          ch = html.charAt(i);

      if (charCode > 0xA0 && charCode < 0x100)
      {
        result += '&#' + charCode + ';';
      }
      else if (ch === '&')
      {
        result += "&amp;";
      }
      else if (ch === '<')
      {
        result += "&lt;";
      }
      else if (ch === '>')
      {
        result += "&gt;";
      }
      else if (ch === '"')
      {
        result += "&quot;";
      }
      else if (ch === "'")
      {
        result += "&#39;";
      }
      else
      {
        result += ch;
      }
    }

    return result;
  };


  this.decodeHtml = (html) =>
  {
    html = html || '';

    return html.replace(/&([A-Za-z0-9#]+);/ig, (str, ent) =>
    {
      if (ent.indexOf('#') === 0)
      {
        ent = ent.substr(1);
        return String.fromCharCode(ent);
      }
      else
      {
        switch (ent.toLowerCase())
        {
          case 'amp':
            return '&';

          case 'lt':
            return '<';

          case 'gt':
            return '>';

          case 'quot':
            return '"';

          default:
            return '&' + ent + ';';
        }
      }
    });
  };


  this.fixGeckoTables = (newWin, newTable) =>
  {
    let i, j,
        tMargin, tMarginLeft, tMarginRight, tMarginTop, tMarginBottom,
        tableBorder, tdBorder, nextTdBorder, calcBorder, calcMargin,
        tableCurrent, tdCurrent,
        pWin = newWin || window,
        waTables = (newTable) ? [newTable] : pWin.document.body.getElementsByTagName('TABLE');

    if (!waTables || !waTables.length)
    {
      return false;
    }

    for (i = 0; i < waTables.length; i++)
    {
      if (waTables[i].getAttribute('watable', 0))
      {
        tableCurrent = waTables[i];

        if (!tableCurrent || !tableCurrent.style)
        {
          continue;
        }

        tMargin = (tableCurrent.style.margin) ? tableCurrent.style.margin : BEditor.styleHelpers.getElementStyle(tableCurrent, 'margin');
        tMargin = (!isNaN(parseInt(tMargin)) && parseInt(tMargin) !== 0);

        tMarginLeft = (tableCurrent.style.marginLeft) ? tableCurrent.style.marginLeft : BEditor.styleHelpers.getElementStyle(tableCurrent, 'marginLeft');
        tMarginLeft = (!isNaN(parseInt(tMarginLeft)) && parseInt(tMarginLeft) !== 0);

        tMarginRight = (tableCurrent.style.marginRight) ? tableCurrent.style.marginRight : BEditor.styleHelpers.getElementStyle(tableCurrent, 'marginRight');
        tMarginRight = (!isNaN(parseInt(tMarginRight)) && parseInt(tMarginRight) !== 0);

        tMarginTop = (tableCurrent.style.marginTop) ? tableCurrent.style.marginTop : BEditor.styleHelpers.getElementStyle(tableCurrent, 'marginTop');
        tMarginTop = (!isNaN(parseInt(tMarginTop)) && parseInt(tMarginTop) !== 0);

        tMarginBottom = (tableCurrent.style.marginBottom) ? tableCurrent.style.marginBottom : BEditor.styleHelpers.getElementStyle(tableCurrent, 'marginBottom');
        tMarginBottom = (!isNaN(parseInt(tMarginBottom)) && parseInt(tMarginBottom) !== 0);

        if (tableCurrent.style.borderCollapse.toLowerCase() === 'collapse' && !tMargin)
        {
          if (!tableCurrent.getAttribute('align', 0) || tableCurrent.getAttribute('align', 0).toLowerCase() !== 'center')
          {
            if (!waTables[i].getAttribute('wamarginleft', 0) && !tMarginLeft)
            {
              tableBorder = (tableCurrent.style.borderLeftWidth) ? tableCurrent.style.borderLeftWidth : BEditor.styleHelpers.getElementStyle(tableCurrent, 'borderLeftWidth');
              tableBorder = (!isNaN(parseInt(tableBorder))) ? parseInt(tableBorder) : 0;
              tdBorder = 0;

              for (j = 0; (j < tableCurrent.rows.length && j < 17); j++)
              {
                if (tableCurrent.rows[j].cells && tableCurrent.rows[j].cells.length > 0)
                {
                  tdCurrent = tableCurrent.rows[j].cells[0];

                  if (tdCurrent && tdCurrent.style)
                  {
                    nextTdBorder = (tdCurrent.style.borderLeftWidth) ? tdCurrent.style.borderLeftWidth : BEditor.styleHelpers.getElementStyle(tdCurrent, 'borderLeftWidth');
                    nextTdBorder = (!isNaN(parseInt(nextTdBorder))) ? parseInt(nextTdBorder) : 0;

                    if (nextTdBorder > tdBorder)
                    {
                      tdBorder = nextTdBorder;
                    }
                  }
                }
              }

              calcBorder = (tableBorder > tdBorder) ? tableBorder : tdBorder;

              if (calcBorder > 0)
              {
                calcMargin = Math.ceil(calcBorder / 2);
                tableCurrent.style.marginLeft = calcMargin + 'px';
                tableCurrent.setAttribute('wamarginleft', 1, 0);
              }
            }

            if (!waTables[i].getAttribute('wamarginright', 0) && !tMarginRight)
            {
              tableBorder = (tableCurrent.style.borderRightWidth) ? tableCurrent.style.borderRightWidth : BEditor.styleHelpers.getElementStyle(tableCurrent, 'borderRightWidth');
              tableBorder = (!isNaN(parseInt(tableBorder))) ? parseInt(tableBorder) : 0;
              tdBorder = 0;

              for (j = 0; (j < tableCurrent.rows.length && j < 17); j++)
              {
                if (tableCurrent.rows[j].cells && tableCurrent.rows[j].cells.length > 0)
                {
                  tdCurrent = tableCurrent.rows[j].cells[tableCurrent.rows[j].cells.length - 1];

                  if (tdCurrent && tdCurrent.style)
                  {
                    nextTdBorder = (tdCurrent.style.borderRightWidth) ? tdCurrent.style.borderRightWidth : BEditor.styleHelpers.getElementStyle(tdCurrent, 'borderRightWidth');
                    nextTdBorder = (!isNaN(parseInt(nextTdBorder))) ? parseInt(nextTdBorder) : 0;

                    if (nextTdBorder > tdBorder)
                    {
                      tdBorder = nextTdBorder;
                    }
                  }
                }
              }

              calcBorder = (tableBorder > tdBorder) ? tableBorder : tdBorder;

              if (calcBorder > 0)
              {
                calcMargin = Math.ceil(calcBorder / 2);
                tableCurrent.style.marginRight = calcMargin + 'px';
                tableCurrent.setAttribute('wamarginright', 1, 0);
              }
            }
          }

          if (!waTables[i].getAttribute('wamargintop', 0) && !tMarginTop)
          {
            tableBorder = (tableCurrent.style.borderTopWidth) ? tableCurrent.style.borderTopWidth : BEditor.styleHelpers.getElementStyle(tableCurrent, 'borderTopWidth');
            tableBorder = (!isNaN(parseInt(tableBorder))) ? parseInt(tableBorder) : 0;
            tdBorder = 0;

            if (tableCurrent.rows && tableCurrent.rows.length > 0 && tableCurrent.rows[0] && tableCurrent.rows[0].cells)
            {
              for (j = 0; (j < tableCurrent.rows[0].cells.length && j < 17); j++)
              {
                tdCurrent = tableCurrent.rows[0].cells[j];

                if (tdCurrent && tdCurrent.style)
                {
                  nextTdBorder = (tdCurrent.style.borderTopWidth) ? tdCurrent.style.borderTopWidth : BEditor.styleHelpers.getElementStyle(tdCurrent, 'borderTopWidth');
                  nextTdBorder = (!isNaN(parseInt(nextTdBorder))) ? parseInt(nextTdBorder) : 0;

                  if (nextTdBorder > tdBorder)
                  {
                    tdBorder = nextTdBorder;
                  }
                }
              }
            }

            calcBorder = (tableBorder > tdBorder) ? tableBorder : tdBorder;

            if (calcBorder > 0)
            {
              calcMargin = Math.ceil(calcBorder / 2);
              tableCurrent.style.marginTop = calcMargin + 'px';
              tableCurrent.setAttribute('wamargintop', 1, 0);
            }
          }

          if (!waTables[i].getAttribute('wamarginbottom', 0) && !tMarginBottom)
          {
            tableBorder = (tableCurrent.style.borderBottomWidth) ? tableCurrent.style.borderBottomWidth : BEditor.styleHelpers.getElementStyle(tableCurrent, 'borderBottomWidth');
            tableBorder = (!isNaN(parseInt(tableBorder))) ? parseInt(tableBorder) : 0;
            tdBorder = 0;

            if (tableCurrent.rows && tableCurrent.rows.length > 0 && tableCurrent.rows[tableCurrent.rows.length - 1] && tableCurrent.rows[tableCurrent.rows.length - 1].cells)
            {
              for (j = 0; (j < tableCurrent.rows[tableCurrent.rows.length - 1].cells.length && j < 17); j++)
              {
                tdCurrent = tableCurrent.rows[tableCurrent.rows.length - 1].cells[j];

                if (tdCurrent && tdCurrent.style)
                {
                  nextTdBorder = (tdCurrent.style.borderBottomWidth) ? tdCurrent.style.borderBottomWidth : BEditor.styleHelpers.getElementStyle(tdCurrent, 'borderBottomWidth');
                  nextTdBorder = (!isNaN(parseInt(nextTdBorder))) ? parseInt(nextTdBorder) : 0;

                  if (nextTdBorder > tdBorder)
                  {
                    tdBorder = nextTdBorder;
                  }
                }
              }
            }

            calcBorder = (tableBorder > tdBorder) ? tableBorder : tdBorder;

            if (calcBorder > 0)
            {
              calcMargin = Math.ceil(calcBorder / 2);
              tableCurrent.style.marginBottom = calcMargin + 'px';
              tableCurrent.setAttribute('wamarginbottom', 1, 0);
            }
          }
        }
      }
    }
  }
}